export default async({ isDesktop, isMobile, redirect, route }) => {
  const { path } = route
  const mobilePath = /^\/m\//.test(path)
  if (isMobile && !mobilePath) {
    redirect('/m/') // TODO: 看情況要不要導轉到兩個裝置的對應路由
  }
}
